import React from 'react';
import { resolve } from 'library/helpers/path-resolver';
import Query from 'apps/hiring/util/query';
import { ShimmyZone } from 'library/components/shimmy';
import withData from 'util/hoc/with-data';
import styled from 'styled-components';

import Loading from 'components/loading';
import PropTypes from 'prop-types';
import EditTargetBody from 'apps/hiring/components/edit-target-body';

const StyledEditTargetModal = styled.div`
  width: calc(1200px + 3em);
  max-height: 920px;
  height: 100%;

  .hiring-modal-header {
    flex: unset;
  }
`;

class EditTargetModal extends React.Component {
  handleModalUpdate = (target_grouping) => {
    if (target_grouping) {
      this.props.reload_graph(true, true);
    }
  }

  render() {
    const {
      graph_data,
      reload,
      reload_graph,
      handleEdit,
      graph_loading,
    } = this.props;

    return (
      <StyledEditTargetModal className="hiring-modal">
        <div className="hiring-modal-header">
          <div className="hiring-modal-header-inner">
            <ShimmyZone namespace="edit-target-modal-header">
              <p>Edit Evaluation <span>Target</span></p>
            </ShimmyZone>
            <a onClick={this.props.onClose} href="javascript:void(0)">×</a>
          </div>
          <svg className="hiring-modal-header-svg" width="100%" height="20px" viewBox="0 0 100 50" preserveAspectRatio="none">
            <path className="hiring-modal-header-svg-first" fill="currentColor" strokeWidth="0" d={`M0,0 100,0 100,50 0,0`}></path>
            <path className="hiring-modal-header-svg-second" fill="currentColor" strokeWidth="0" d={`M0,0 100,0 0,50 0,0`}></path>
          </svg>
        </div>
        <div className="hiring-modal-body">
          {
            graph_loading
              ? <Loading />
              : (
                <EditTargetBody
                  target={resolve(graph_data, 'target_grouping', {})}
                  onClose={this.props.onClose}
                  loading={this.props.graph_loading}
                  onUpdate={this.handleModalUpdate}
                  reloadParent={reload}
                  reloadGraph={reload_graph}
                  handleEdit={handleEdit}
                  onAddEmployee={this.handleAddEmployee}
                />
              )
          }
        </div>
        <div className="hiring-modal-footer">
          <ShimmyZone namespace="edit-target-modal-footer">
          </ShimmyZone>
        </div>
      </StyledEditTargetModal>
    );
  }
}

EditTargetModal.query = (CancelToken, { id, node_id=null }) => (
  Query(`
    {
      target_grouping (id:${id} ${node_id ? `, node_id:${node_id}` : ``}) {
        finalized,
        id,
        name,
        type,
        archived,
        description,
        assessments {
          id,
          completion_date,
          user {
            first_name,
            last_name,
            match(target_id:${id})
          }
        }
        targets {
          id,
          characteristic_id,
          confidence,
          characteristic {
            id
            name
          }
          percentile_range {
            start,
            end
          }
        }
      }
    }
  `, null, {redirectOnUnauthorized:false})

);

EditTargetModal.parseQueryData = (data) => ({
  target_grouping: resolve(data, 'target_grouping', {}),
  targets: resolve(data, 'targets', {})
});

EditTargetModal.propTypes = {
  onClose: PropTypes.func,
  graph_update: PropTypes.func,
  graph_loading: PropTypes.bool,
  graph_data: PropTypes.object,
  reload_graph: PropTypes.func,
  reload: PropTypes.func,
  handleEdit: PropTypes.func,
  id: PropTypes.number
};

export default withData(EditTargetModal);
